const config = {
    brand: "PristaneLAVERIE®",
    reducePercentage: "10%",
    street: "41 Rue du Chablais",
    city: "74100 Annemasse",
    opening_hours: "7"
};

export default config;